import { useState } from 'react';
import { useTranslation } from '@klv/hooks/useTranslation';

import Icon from '@klv/atoms/icon';
import { generateClassName } from '@klv/shared/utils/functions';

import SignupForm from './form';
import SignupFormInvisibleReCaptcha from './formInvisibleReCaptcha';
import SignupFormTwoColumn from './formTwoColumn';
import SimpleSignupForm from './simpleForm';
import FormWrapper from '../wrapper';
import type { ISignup } from '../types';

import * as styles from '../styles/forms.module.scss';

const Signup = ({
  backgroundColor = 'light',
  bodyCopy = '',
  buttonPlacementDecision = false,
  formState,
  fullWidth = false,
  headline = '',
  inHero = false,
  recaptchaInstance = 'visible',
  showAgencyFields = false,
  templateName,
  layout,
  ...props
}: ISignup) => {
  const { t } = useTranslation();
  const [success, setSuccess] = useState(false);


  let SignupFormComponent = SignupForm;
  if (recaptchaInstance === 'invisible') {
    SignupFormComponent = SignupFormInvisibleReCaptcha;
  }
  if (layout === 'twoColumn') {
    SignupFormComponent = SignupFormTwoColumn;
  }
  if (layout === 'simple') {
    SignupFormComponent = SimpleSignupForm;
  }

  return (
    <FormWrapper
      backgroundColor={backgroundColor}
      inHero={inHero}
      fullWidth={fullWidth}
      logo={<Icon className={styles.logo} iconName="Logo" fillColor="currentColor" role="img" aria-label="Klaviyo Logo" />}
    >
      {!success && !buttonPlacementDecision && (
      <header>
        <h2 
          className={generateClassName(['h2', styles.headline])}
          dangerouslySetInnerHTML={headline ? { __html: headline } : undefined}
        >
          {headline ? null : t('organisms_forms_signup_headline')}
        </h2>
        <p 
          className={generateClassName(['p1', styles.marginBottom25])}
          dangerouslySetInnerHTML={{ __html: bodyCopy || t('organisms_forms_signup_body') }}
        />
      </header>
      )}

      <SignupFormComponent
        formState={formState}
        showAgencyFields={showAgencyFields}
        setSuccess={setSuccess}
        backgroundColor={backgroundColor}
        buttonPlacementDecision={buttonPlacementDecision}
        {...props}
      />
    </FormWrapper>
  );
};

export default Signup;
